"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hiddenContentStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden'
};
//# sourceMappingURL=hiddenContentStyle.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/~/@uifabric/styling/lib/styles/hiddenContentStyle.js
// module id = ../node_modules/office-ui-fabric-react/node_modules/@uifabric/styling/lib/styles/hiddenContentStyle.js
// module chunks = 1